import loadable from '@loadable/component';

export const OrgDashboardViewJobPageContainerLoadable = loadable(
  () => import('./OrgDashboardViewJobPageContainer'),
  { resolveComponent: (module) => module.OrgDashboardViewJobPageContainer },
);
